export const adminEmails = ['sylvesterdavidswork@gmail.com', 'sylvesterdavzzz@gmail.com', 'rize@inaragroups.com'];